// extracted by mini-css-extract-plugin
module.exports = {"product-footer":"style_product-footer__3pafz","stock__text":"style_stock__text__21jiY"};